/**
 * Feature flag name constants for the CIEDA platform.
 *
 * These are the canonical identifiers for all product-level flags.
 * They must match the `key` column values in the `feature_flags` table.
 *
 * Usage:
 *   import { FLAG_NAMES } from '@cieda/shared/feature-flags';
 *   const enabled = useFeatureFlag(FLAG_NAMES.CHECKOUT_ENABLED);
 */

export const FLAG_NAMES = {
  /** Enable the checkout flow (cart → livraison → paiement) */
  CHECKOUT_ENABLED: "commerce.checkout.enabled",

  /** Enable the product catalogue page (/catalogue) */
  CATALOGUE_ENABLED: "commerce.catalogue.enabled",

  /** Enable cash-on-delivery payment method */
  COD_ENABLED: "commerce.payment.cod_enabled",

  /** Enable admin delivery zone management UI */
  ADMIN_DELIVERY_ZONES: "admin.delivery.zones_enabled",

  /** Enable admin operations hub and sub-pages */
  ADMIN_OPERATIONS: "admin.operations.enabled",
} as const;

/** Union type of all flag names for strict typing. */
export type FlagName = (typeof FLAG_NAMES)[keyof typeof FLAG_NAMES];

/**
 * Flags that are safe to expose publicly without authentication.
 * These are returned by GET /api/feature-flags (no auth required).
 */
export const PUBLIC_FLAGS: readonly FlagName[] = [
  FLAG_NAMES.CHECKOUT_ENABLED,
  FLAG_NAMES.CATALOGUE_ENABLED,
  FLAG_NAMES.COD_ENABLED,
] as const;
